<section class="not-authorized">
  <div class="card">
    <span class="material-icons">lock</span>
    <h1>Yetkiniz yok</h1>
    <p>Portal uygulamasına sadece superadmin/admin kullanıcılar erişebilir.</p>
    <a routerLink="/">
      <lib-button variant="primary">Portala dön</lib-button>
    </a>
  </div>
</section>
